<!--
 * @Author: WangYuzhou
 * @Date: 2023-01-04 23:37:06
 * @LastEditors: WangYuzhou
 * @LastEditTime: 2024-06-12 00:47:41
 * @Description: TODO
-->
<template>
    <div class="turnover-div col">
        <div class="row">
            <div v-for="item in ['年','月','日']" :key="item" :class="['item', item==select?'select-item':'normal-item']" @click="test(item)">
                {{ item }}
            </div>
        </div>
        <dv-scroll-board :config="{ ...config, data:data[select] }" class="mt10"/>
    </div>
</template>

<script>
export default {
  name: 'Turnover',
  props: {
    data: {
      type: Array
    }
  },
  // 091d45 1
  // 0f3058 2
  data () {
    return {
      select: '日',
      config: {
        data: [

        ],
        index: true,
        columnWidth: [50],
        align: ['center', 'left', 'right', 'right'],
        rowNum: 8,
        oddRowBGC: '#091d45',
        evenRowBGC: '#0f3058'
      }
    }
  },
  methods: {
    test (item) {
      this.select = item
    }
  }
}
</script>

<style lang="less" >
.turnover-div{
    height: 100%;

    .item{
        line-height: 30px;
        width: 40px;
        text-align: center;
        font-size: 14px;
        border: 1px solid #26defd;
        margin-right: 10px;
    }
    .select-item{
        background-color: #26defd;
    }
    .normal-item{
        background-color: transparent;
    }
}
</style>
